import { render } from "./ClientDeliverableCreativeAssetComments.vue?vue&type=template&id=cbb96c2a"
import script from "./ClientDeliverableCreativeAssetComments.vue?vue&type=script&lang=js"
export * from "./ClientDeliverableCreativeAssetComments.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/laravel/sundae-scoops/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__